import {
  parseCustomFieldAnswers,
  parseCustomFieldDefinitions,
} from "@/domain/custom-fields/schema";
import type { CustomFieldAnswer, CustomFieldDefinition } from "@/domain/custom-fields/types";
import { observability } from "@/lib/observability";

/** Unreadable json maps to null, which on an offer is indistinguishable from
 *  "inherit the activity's questions" — the opposite of the override the partner
 *  stored. Nothing in the UI can show that, so it is reported here instead. */
export function readCustomFieldDefinitions(
  value: unknown,
  column: string,
): CustomFieldDefinition[] | null {
  const definitions = parseCustomFieldDefinitions(value);
  if (definitions === null) reportUnreadable(value, column);
  return definitions;
}

export function readCustomFieldAnswers(value: unknown, column: string): CustomFieldAnswer[] | null {
  const answers = parseCustomFieldAnswers(value);
  if (answers === null) reportUnreadable(value, column);
  return answers;
}

/** Shape only, never the payload: answers are customer-entered content and this
 *  context leaves the app for Sentry. */
function reportUnreadable(value: unknown, column: string): void {
  if (value === null || value === undefined) return;
  observability.captureError(new Error(`Unreadable custom fields json in ${column}`), {
    column,
    jsonType: Array.isArray(value) ? "array" : typeof value,
    ...(Array.isArray(value) ? { arrayLength: value.length } : {}),
  });
}
